import { render } from "./PromptTemplateBuilder.vue?vue&type=template&id=a8262230&scoped=true&ts=true"
import script from "./PromptTemplateBuilder.vue?vue&type=script&lang=ts"
export * from "./PromptTemplateBuilder.vue?vue&type=script&lang=ts"

import "./PromptTemplateBuilder.vue?vue&type=style&index=0&id=a8262230&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8262230"]])

export default __exports__